import { getCommentHistoriesById } from "../../api/requests"
import { HistoryItem } from "../../Components/History/types"
import { useEffect, useState } from "react"
import { useParams } from 'react-router-dom';


export const useListHistoryState = () => {
    const [state, setState] = useState<ReadonlyArray<HistoryItem>>([])
    const { id } = useParams() as {readonly id: string};
    const getCommentHistoriesState = async () => {
        const commentHistories = await getCommentHistoriesById(parseInt(id, 10))
        setState(commentHistories)
    }

    useEffect(()=> {
        getCommentHistoriesState()
    }, [])

    return {
        commentHistories: state
    }
}